module.exports = __webpack_public_path__ + "img/about-zhinengwanglian.f45d97bd.png";